import { useEffect } from "react";
import "./Banner.scss";
import arrowsgroup from "../../assets/images/arrowsgroup.svg";

const CommonBanner = ({
  id,
  titleMobile,
  titleDesktop,
  subtitle,
  titleClass,
}) => {
  useEffect(() => {
    const parallax = document.getElementsByClassName("banner-subpage")[0];

    window.addEventListener("scroll", function () {
      let offset = window.pageYOffset;
      if (parallax) {
        parallax.style.backgroundPositionY = offset * 0.7 + "px";
      }
    });

    return () => {
      window.removeEventListener("scroll", function () {
        let offset = window.pageYOffset;
        if (parallax) {
          parallax.style.backgroundPositionY = offset * 0.7 + "px";
        }
      });
    };
  }, []);

  return (
    <div id={id} className="banner-subpage">
      <img alt="arrows-group" src={arrowsgroup} className="arrows-group" />
      <div className="container">
        {titleMobile && (
          <div className="title mobile">
            {titleMobile} <br />
            <span>{subtitle}</span>
          </div>
        )}
        {titleDesktop && (
          <div className={`title ${titleClass}`}>
            {titleDesktop} <span>{subtitle}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default CommonBanner;
